import { ProductDate } from '../../lib/types/models/product/product-date'
import {
  ProductDateFormInput,
  ProductDateInput
} from '../../lib/types/models/product/product-date-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type UpdateProductDateInput = Partial<ProductDateFormInput> & Pick<ProductDateInput, 'productId'>

export function updateProductDate(data: IdInput<UpdateProductDateInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.products.updateProductDate.url, { id }))
    .patch<ProductDate, UpdateProductDateInput>(rest)
}

export const lockProductDate = (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.products.lockProductDate.url, { id }))
    .post<ProductDate>()
}

export const unlockProductDate = (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.products.unlockProductDate.url, { id }))
    .post<ProductDate>()
}
